import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'components/form';
import Button from 'components/button';
import { getStorefrontURL } from 'utils/storefront';

import './storefront.scss';

export default class StorefrontNewFindAPartner extends React.PureComponent {
  static contextTypes = {
    user: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired,
  };

  state = {
    submitted: false,
  };

  isStorefrontAppWithThemes = (app) => {
    return (
      app.type === 'storefront' && app.storefront?.theme?.provider === 'app'
    );
  };

  onSubmitForm = (values) => {
    this.props.onSubmitFindAPartner(values);
    this.setState({ submitted: true });
  };

  render() {
    const { apps, primaryStorefront } = this.props;
    const { user, client } = this.context;
    const { submitted } = this.state;

    const storefrontThemeApps = apps.results.filter(
      this.isStorefrontAppWithThemes,
    );

    return (
      <div className="storefront-apps-find-partner">
        {submitted ? (
          <div className="storefront-apps-find-partner-subheader">
            <div className="view-body-title">Thank you!</div>
            <div className="view-body-subtitle">
              Your request has been submitted. We'll connect get back to you by
              email within
              <br /> 1-2 business days with a selection of preferred partners.
            </div>
          </div>
        ) : (
          <Form onSubmit={this.onSubmitForm} autoFocus={true}>
            <div className="storefront-apps-find-partner-subheader">
              <div className="view-body-title">
                Bring your ecommerce vision to life
              </div>
              <div className="view-body-subtitle">
                Enter a few details about your project and we'll connect you
                with our preferred partners.
              </div>
            </div>
            <fieldset>
              <div className="row">
                <Field
                  type="text"
                  name="name"
                  label="Name"
                  defaultValue={user.name}
                  placeholder="Your name"
                  required={true}
                  className="span2"
                />
                <Field
                  type="email"
                  name="email"
                  label="Email"
                  defaultValue={user.email}
                  placeholder="Your email address"
                  required={true}
                  className="span2"
                />
              </div>
              <div className="row">
                <Field
                  type="text"
                  name="company"
                  label="Company"
                  defaultValue={client.name}
                  placeholder="Your company"
                  required={true}
                  className="span2"
                />
                <Field
                  type="text"
                  name="website"
                  label="Website"
                  defaultValue={getStorefrontURL(primaryStorefront)}
                  placeholder="Company website"
                  className="span2"
                />
              </div>
              <div className="row">
                <Field
                  buttons={true}
                  type="radio"
                  name="budget"
                  label="Your budget"
                  options={[
                    { label: 'Under $10K', value: 'under_10k' },
                    { label: '$10K - $50K', value: '10k_to_50k' },
                    { label: '$50K - $100K', value: '50k_to_100k' },
                    { label: '$100K+', value: '100k_plus' },
                  ]}
                  required={true}
                  className="span4"
                />
              </div>
              <div className="row">
                <Field
                  type="textarea"
                  name="description"
                  label="Describe your project"
                  rows={5}
                  required={true}
                  className="span4"
                  hint="Include details about your business, goals, and any specific requirements you have."
                />
              </div>
              <div className="storefront-apps-find-partner-actions">
                <Button type="submit" size="md">
                  Submit request
                </Button>
              </div>
            </fieldset>
          </Form>
        )}
      </div>
    );
  }
}
